import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../../app/redux/hooks';
import AppLogger from '../../../../common/logger/AppLogger';
import {
  OperatorLevel,
  useGetWorkstationLocationsQuery,
  useLazyGetWorkstationsQuery,
  useSetWorkstationLocationMutation,
} from '../../../api';
import { setWorkstation, useOperatorSession, useWorkstation } from '../../../appState';
import { showErrorDialog } from '../../../error-dialog/errorDialogSlice';
import '../workstation-order-device/styles.sass';

function errorMessage(status: unknown) {
  if (status === 403) return 'Only an Admin can set the till location';
  if (status === 400) return 'That location is not at this site';
  return 'Failed to set till location';
}

export default function WorkstationLocationPicker() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const operatorSession = useOperatorSession();
  const workstation = useWorkstation();

  const { data: locations } = useGetWorkstationLocationsQuery();
  const [triggerSet, { isLoading }] = useSetWorkstationLocationMutation();
  const [triggerWorkstation] = useLazyGetWorkstationsQuery();

  if (operatorSession == null || operatorSession.operator.operatorLevel !== OperatorLevel.Admin) return <div></div>;

  const current = workstation?.workstationLocationId ?? null;

  const onClick = (workstationLocationId: number | null) => {
    triggerSet({ operatorId: operatorSession.operator.id, workstationLocationId })
      .unwrap()
      .then(() => triggerWorkstation().unwrap())
      .then((ws) => {
        dispatch(setWorkstation(ws));
        navigate('/order');
      })
      .catch((error) => {
        AppLogger.error('Failed to set till location', JSON.stringify(error));
        dispatch(
          showErrorDialog({
            message: errorMessage(error?.status),
            dismissible: true,
            buttonText: 'OK',
          }),
        );
      });
  };

  return (
    <div className="pos-modal-portal">
      <div
        className="pos-modal-overlay"
        onClick={(e) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if ((e.target as any).className === 'pos-modal-overlay') navigate('/order');
        }}
      >
        <div className="pos-modal pos-modal_role_servers-overview">
          <div className="pos-modal__content">
            <div className="pos-servers-overview">
              <div className="pos-servers-overview__header">
                <h2 className="pos-servers-overview__title">Till Location</h2>
                <p className="pos-sign-in__subtitle">Currently: {workstation?.workstationLocationName ?? 'No location'}</p>
              </div>
              <div className="wod-edit">
                <div className="grid">
                  <button className="default" disabled={isLoading || current === null} onClick={() => onClick(null)}>
                    No location
                  </button>
                  {locations &&
                    locations.map((location) => (
                      <button key={location.id} disabled={isLoading || location.id === current} onClick={() => onClick(location.id)}>
                        {location.locationName}
                      </button>
                    ))}
                </div>
                {locations && locations.length === 0 && <p className="pos-sign-in__subtitle">No locations set up for this site</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
